// Agent-facing reply sent when the user skips a `request_connection` card.
//
// Unlike the other card actions, skipping posts NO tool result. Rain closes out
// a pending remote tool call as soon as user-authored input lands — it appends a
// cancellation `ToolResult` before the message, under the generation lock (see
// `redirect_recovery.rs::close_out_events` in the rain repo). So replying is
// both the cancel and the explanation: the agent reads the user's intent rather
// than a synthetic failure, and can carry on without the integration.
//
// Kept verbatim in sync with the English pill label
// (`rain.requestConnection.skip`) so what the user clicks is exactly what the
// agent receives — the same contract as the max-iterations replies in
// `./max-iterations.ts`.
export const skipConnectionMessage = (appName: string): string =>
  `Skip the ${appName} connection for now.`;
